import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
export var MqqNamespace = /*#__PURE__*/function (MqqNamespace) {
  MqqNamespace["Docx"] = "docx";
  MqqNamespace["Nav"] = "nav";
  return MqqNamespace;
}({});
export var MqqErrorName = /*#__PURE__*/function (MqqErrorName) {
  MqqErrorName["UnknownMqqError"] = "UnknownMqqError";
  return MqqErrorName;
}({});
export function invokeMqq(_x) {
  return _invokeMqq.apply(this, arguments);
}
function _invokeMqq() {
  _invokeMqq = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            window.mqq.invoke(payload.namespace, payload.methodName, payload.data,
            // 原生错误交由上层处理
            resolve);
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _invokeMqq.apply(this, arguments);
}
//# sourceMappingURL=mqq.js.map